import green from 'material-ui/colors/green';
import grey from 'material-ui/colors/grey';
import lime from 'material-ui/colors/lime';
import yellow from 'material-ui/colors/yellow';
import red from 'material-ui/colors/red';
import blue from 'material-ui/colors/blue';

export const builderStyles = theme => ({

    // General
    root: theme.mixins.gutters({
        padding: '25px 0 55px 0px',
        marginTop: 10,
        marginBottom: 10,
        position: 'relative',
    }),
    marginTop0: {
        marginTop:0,
    },
    buttonWrapper: {
        marginTop: theme.spacing.unit,
        position: 'relative',
    },
    progressIcon: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        marginTop: -12,
        marginLeft: -30,
    },
    disabledSaveButton: {
        width: 150,
    },
    saveButton: {
        width: 150,
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    discardButton: {
        width: 150,
        marginLeft: '10px',
    },
    buttonPreview: {
        width: 150,
        marginLeft: '10px',
        backgroundColor: blue[500],
        '&:hover': {
            backgroundColor: blue[700],
        },
    },
    darkGreen: {
        padding: 6,
        backgroundColor: green[700]
    },
    green: {
        padding: 6,
        backgroundColor: green[200]
    },
    red: {
        padding: 6,
        backgroundColor: red[300]
    },
    warning: {
        padding: 6,
        backgroundColor: yellow[300],
        position: 'relative',
    },
    saveWarning:{
        zIndex:1
    },
    card1: theme.mixins.gutters({
        marginBottom: theme.spacing.unit * 0.5,
        marginTop: theme.spacing.unit * 0.5,
    }),
    marginBottom10: {
        marginBottom: theme.spacing.unit,
    },
    opacityBackdrop: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)'
    },

    // Sections
    new: {
        backgroundColor: yellow[100],
        '& .textBlockPlaceholder .text-row': {
            background: '#FFCB82 !important'
        }
    },
    chipWebsite: {
        margin: theme.spacing.unit,
    },
    chipWebsiteBackground: {
        margin: theme.spacing.unit,
    },
    snackbar: {
        maxWidth: '100%',
        marginBottom: '10px',
        marginTop: '10px',
        backgroundColor: grey[500]
    },
    touched: {
        backgroundColor: grey[200],
        '& .textBlockPlaceholder .text-row': {
            background: '#ffffff !important'
        }
    },
    pbSectionTitle: {
        color: theme.palette.primary[500],
    },
    pbSectionBody:{
        color: theme.palette.text,
    },
    pbSectionCaption: {
        marginTop: 15,
    },
    pbSectionDrag: {
        position: 'absolute',
        top: 15,
        cursor: 'pointer',
        marginTop: 13,
        width: '108px',
        right: '-75px'
    },
    pbSectionActions: {
        width: 50,
        position: 'absolute',
        right: 0,
        bottom: 0,
        padding: 10,
        cursor: 'pointer',
        '&:hover': {
            background:'linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(150, 150, 150, 0.3) 100%)',
        },
    },
    pbSortSectionActions: {
        width: 40,
        position: 'absolute',
        right: 10,
        bottom: 0,
        cursor: 'pointer'
    },
    pbSortSectionActionsDelete: {
        width: 80,
        float: 'right',
        bottom: 0,
        right: -55,
        position: 'absolute',
    },
    pbActionsEdit: {
        color: theme.palette.text.secondary,
        '&:hover': {
            color: theme.palette.primary[500]
        }
    },
    pbActionsVisible: {
        color: theme.palette.text.secondary,
        '&:hover': {
            color: yellow[700]
        }
    },
    pbActionsInvisible: {
        color: theme.palette.text.secondary,
        '&:hover': {
            color: green[300]
        }
    },
    pbSection: {

    },
    pbSectionReadonly: {
        backgroundColor: lime[50],
        '& h2' : {
            color: grey[400],
            padding: 0,
            margin: 0
        },
        '& .body' : {
            color: grey[400],
        }
    },
    selectMenuItem: {
        fontSize: '14px',
        padding: '0 15px'
    },
    dialogActionsBtn: {
        margin: '8px 19px'
    },

    // Elements
    pbElement: {
        background: theme.palette.background.default,
        padding: 10,
        marginBottom: 10,
        cursor: 'grab',
        borderRadius: 3,
        '&:active': {
            cursor: 'grabbing',
        },
        '&:hover':{
            background:'linear-gradient(45deg, #ffffff 10%, #EEEEEE 100%)'
        },
        '& img': {
            float: 'left',
        },
    },
    pbElementImage: {
        float: 'left',
        marginRight: 25,
        width: 37,
    },
    pbElementText: {
        fontSize: 16,
        margin: 0,
        height: 28,
    },
    shadow: {
        boxShadow: '0 1px 5px 0px rgba(0, 0, 0, .2)',
    },
    rowAvatars: {
        display: 'flex',
        marginLeft: '-10px'
    },
    row: {
        display: 'flex',
    },
    avatar: {
        margin: 5,
    },
    bigAvatar: {
        width: 60,
        height: 60,
    },
    locationGroup: {
        marginTop: '20px !important'
    },
    sectionTitle: {
        margin: theme.spacing.unit
    },
    sectionTitleChip: {
        margin: theme.spacing.unit,
        marginLeft: 0
    },
    headingTitle: {
        color: '#666',
        padding: '12px 0 12px 20px',
    },
});


// WEBPACK FOOTER //
// ./src/containers/templates/builder/style/builder.js